import { Link } from "react-router";

import {
  JobCandidacyCountsByStatus,
  JobEdit,
  JobOverview,
  JobPipeline,
  JobPrescreeningQuestions,
  JobStats,
  JobStatusDropdown,
  TopbarContainer,
  TopbarTitle,
} from "@/components";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { useCurrentCompanyId } from "@/hooks";
import { useGetJob } from "@/hooks/queries";
import { useSetJob } from "@/hooks/sets";
import { JobStatus } from "@/types";

export const JobPage = () => {
  const currentCompanyId = useCurrentCompanyId();
  const { data: job, status: jobStatus } = useGetJob();
  const setJob = useSetJob();

  if (jobStatus === "pending") {
    // TODO: Loading state.
    return null;
  } else if (jobStatus === "error") {
    // TODO: Error state.
    return null;
  }

  return (
    <div className="flex h-svh flex-col">
      <TopbarContainer className="flex items-center justify-between">
        <TopbarTitle className="!text-slate-500">
          <Link
            className="hover:underline"
            // TODO: Should really have a util that serves as a source of truth for the routes.
            to={`/companies/${currentCompanyId}/jobs`}
          >
            Jobs
          </Link>{" "}
          / <span className="text-slate-700">{job.title}</span>
        </TopbarTitle>
        <JobStatusDropdown job={job} setJob={setJob} />
      </TopbarContainer>
      <Tabs
        className="flex min-h-0 flex-1 flex-col gap-6 pt-6"
        defaultValue="overview"
      >
        <div className="px-6">
          <TabsList>
            {/* TODO: Better mechanism for setting the width of the tabs and ensuring they do not shift when switching.  */}
            <TabsTrigger className="w-[100px]" value="overview">
              Overview
            </TabsTrigger>
            <TabsTrigger className="w-[100px]" value="edit">
              Edit Job
            </TabsTrigger>
            <TabsTrigger className="w-[200px]" value="screening">
              Pre-Screening Questions
            </TabsTrigger>
            <TabsTrigger
              className="w-[100px]"
              disabled={
                job.status === JobStatus.REVIEW ||
                job.status === JobStatus.DRAFT
              }
              value="pipeline"
            >
              Pipeline
            </TabsTrigger>
          </TabsList>
        </div>
        <TabsContent className="flex-1" value="overview">
          <div className="flex h-full flex-col gap-6">
            <JobCandidacyCountsByStatus className="px-6" />
            <div className="flex h-full border-t border-slate-200">
              <JobOverview className="w-full p-6" job={job} />
              {job.status !== JobStatus.CLOSED && (
                <JobStats
                  className="w-[375px] shrink-0 border-l border-slate-200 p-6"
                  job={job}
                />
              )}
            </div>
          </div>
        </TabsContent>
        <TabsContent value="edit">
          <JobEdit className="p-10" job={job} />
        </TabsContent>
        <TabsContent value="screening">
          <JobPrescreeningQuestions className="p-6" job={job} />
        </TabsContent>
        <TabsContent className="min-h-0" value="pipeline">
          <JobPipeline className="h-full p-6 pt-0" />
        </TabsContent>
      </Tabs>
    </div>
  );
};
